// Generated by ReScript, PLEASE EDIT WITH CARE

import * as View from "../../primitives/View.res.js";
import * as Spaces from "../theme/Spaces.res.js";
import * as Stylex from "@stylexjs/stylex";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
let styles = {
  root: {
    "display-k1xSpc": "display-x78zum5",
    "flexDirection-kXwgrk": "flexDirection-x1q0g3np",
    $$css: "wino-gc:src/resources/layout-and-structure/Inline.res.js:10"
  },
  grow: {
    "flex-kUk6DE": "flex-x98rzlu",
    $$css: "wino-gc:src/resources/layout-and-structure/Inline.res.js:14"
  },
  fullWidth: {
    "width-kzqmXN": "width-xh8yej3",
    $$css: "wino-gc:src/resources/layout-and-structure/Inline.res.js:17"
  },
  wrap: {
    "flexWrap-kwnvtZ": "flexWrap-x1a02dak",
    $$css: "wino-gc:src/resources/layout-and-structure/Inline.res.js:20"
  },
  shrink: {
    "minWidth-k7Eaqz": "minWidth-xeuugli",
    $$css: "wino-gc:src/resources/layout-and-structure/Inline.res.js:23"
  },
  alignStart: {
    "justifyContent-kjj79g": "justifyContent-x1nhvcw1",
    $$css: "wino-gc:src/resources/layout-and-structure/Inline.res.js:26"
  },
  alignEnd: {
    "justifyContent-kjj79g": "justifyContent-x13a6bvl",
    $$css: "wino-gc:src/resources/layout-and-structure/Inline.res.js:29"
  },
  alignCenter: {
    "justifyContent-kjj79g": "justifyContent-xl56j7k",
    $$css: "wino-gc:src/resources/layout-and-structure/Inline.res.js:32"
  },
  alignSpaceBetween: {
    "justifyContent-kjj79g": "justifyContent-x1qughib",
    $$css: "wino-gc:src/resources/layout-and-structure/Inline.res.js:35"
  },
  alignSpaceAround: {
    "justifyContent-kjj79g": "justifyContent-x1l1ennw",
    $$css: "wino-gc:src/resources/layout-and-structure/Inline.res.js:38"
  },
  alignYTop: {
    "alignItems-kGNEyG": "alignItems-x1cy8zhl",
    $$css: "wino-gc:src/resources/layout-and-structure/Inline.res.js:41"
  },
  alignYBottom: {
    "alignItems-kGNEyG": "alignItems-xuk3077",
    $$css: "wino-gc:src/resources/layout-and-structure/Inline.res.js:44"
  },
  alignYCenter: {
    "alignItems-kGNEyG": "alignItems-x6s0dn4",
    $$css: "wino-gc:src/resources/layout-and-structure/Inline.res.js:47"
  },
  alignYStretch: {
    "alignItems-kGNEyG": "alignItems-x1qjc9v5",
    $$css: "wino-gc:src/resources/layout-and-structure/Inline.res.js:50"
  },
  alignYBaseline: {
    "alignItems-kGNEyG": "alignItems-x1pha0wt",
    $$css: "wino-gc:src/resources/layout-and-structure/Inline.res.js:53"
  }
};
function styleProps(grow, fullWidth, wrap, shrink, space, align, alignY, appendStyle) {
  let gapValue = Spaces.toPx(space);
  return Stylex.props(styles.root, {
    columnGap: gapValue,
    rowGap: `max(calc(` + gapValue + ` / 2), ` + "4px" + `)`
  }, grow ? styles.grow : {}, fullWidth ? styles.fullWidth : {}, wrap ? styles.wrap : {}, shrink ? styles.shrink : {}, align === "end" ? styles.alignEnd : align === "start" ? styles.alignStart : align === "center" ? styles.alignCenter : align === "spaceBetween" ? styles.alignSpaceBetween : styles.alignSpaceAround, alignY === "stretch" ? styles.alignYStretch : alignY === "top" ? styles.alignYTop : alignY === "center" ? styles.alignYCenter : alignY === "baseline" ? styles.alignYBaseline : styles.alignYBottom, appendStyle !== undefined ? Primitive_option.valFromOption(appendStyle) : {});
}
function Inline(props) {
  let __shrink = props.shrink;
  let __wrap = props.wrap;
  let __fullWidth = props.fullWidth;
  let __grow = props.grow;
  let __alignY = props.alignY;
  let __align = props.align;
  let __space = props.space;
  let space = __space !== undefined ? __space : "xxsmall";
  let align = __align !== undefined ? __align : "start";
  let alignY = __alignY !== undefined ? __alignY : "center";
  let grow = __grow !== undefined ? __grow : false;
  let fullWidth = __fullWidth !== undefined ? __fullWidth : false;
  let wrap = __wrap !== undefined ? __wrap : false;
  let shrink = __shrink !== undefined ? __shrink : false;
  let match = styleProps(grow, fullWidth, wrap, shrink, space, align, alignY, props.stylex);
  return JsxRuntime.jsx(View.make, {
    children: props.children,
    className: match.className,
    style: match.style
  });
}
let make = Inline;
export { make };
/* styles Not a pure module */